import { render, staticRenderFns } from "./UlFileRegister.vue?vue&type=template&id=1775f503&scoped=true&"
import script from "./UlFileRegister.vue?vue&type=script&lang=ts&"
export * from "./UlFileRegister.vue?vue&type=script&lang=ts&"
import style0 from "./UlFileRegister.vue?vue&type=style&index=0&id=1775f503&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775f503",
  null
  
)

export default component.exports